/* unplugin-vue-components disabled */import script from "./AddPersonAuditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPersonAuditModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPersonAuditModal.vue?vue&type=style&index=0&id=ba50834c&lang=scss"

const __exports__ = script;

export default __exports__